<template>
  <header :id="id" :class="['header', props.variant]">
    <div class="container-content header-content">
      <div class="header-logo">
        <div v-if="$slots.logo" class="logo-content">
          <slot name="logo" />
        </div>
      </div>
      <slot name="language-selector" />
    </div>
  </header>
</template>

<script setup>
const props = defineProps({
  id: { type: String, default: 'bm-header' },
  variant: {
    type: String,
    required: false,
    default: 'light',
    validator: value => ['light', 'blue'].includes(value)
  }
});
</script>

<style scoped>
.header {
  flex-shrink: 0;
  border-bottom: var(--border-width-b-1) solid var(--neutral-border-default);
  background-color: var(--neutral-surface-subtle);
  color: var(--primary-text-icon-default);
  font-family: var(--body-small-reg-family), sans-serif;
  font-style: normal;
  font-size: var(--label-caption-reg-size);
  font-weight: var(--label-caption-reg-weight);
  line-height: var(--label-caption-reg-line-height);
  padding: var(--pad-space-sp-20) var(--pad-space-sp-40);
}

.header.blue {
  background-color: var(--blue-gls);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-logo {
  display: inline-flex;
}

.logo-content {
  display: inline-flex;
}

@media (min-width: 1024px) {
  .header {
    font-size: var(--body-small-reg-size);
    font-weight: var(--body-small-reg-weight);
    line-height: var(--line-height-lead-sm);
    padding: var(--pad-space-sp-20) 0;
    display: flex;
  }

  .header-content {
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
  }
}
</style>
